import { combineReducers } from "redux";
import userReducer from './user';
import errorReducer from './message'
import  cryptoSlice  from "./crypto";
const rootReducer=combineReducers({user:userReducer,error:errorReducer,crypto:cryptoSlice})

export default rootReducer;